/**
 * Upload size limits, shared so the client can reject an over-limit file before
 * it is sent and the server can enforce the same ceiling.
 *
 * These are the defaults; the server's env (MAX_UPLOAD_BYTES /
 * MAX_VIDEO_UPLOAD_BYTES) is authoritative and may override them. The client
 * uses these constants only for the pre-flight check and the message it shows —
 * the server remains the real gate. Keep the two in step: if the env limits are
 * raised, raise these too so the client stops rejecting files the server would
 * now accept.
 */
/** Documents, images, and everything that is not video. */
export const MAX_UPLOAD_BYTES = 100 * 1024 * 1024;
/** Video, which routinely runs larger than the general limit. */
export const MAX_VIDEO_UPLOAD_BYTES = 200 * 1024 * 1024;
/** Content types billed against the larger video ceiling. */
export const VIDEO_CONTENT_TYPES = ["video/mp4", "video/quicktime", "video/webm", "video/x-msvideo"];
/** The limit that applies to a given file, by its content type. */
export function uploadLimitFor(contentType) {
    return VIDEO_CONTENT_TYPES.includes(contentType) ? MAX_VIDEO_UPLOAD_BYTES : MAX_UPLOAD_BYTES;
}
/** Whole megabytes, for a human-readable limit message. */
export function bytesToMb(bytes) {
    return Math.floor(bytes / 1024 / 1024);
}
//# sourceMappingURL=upload.js.map